import { useMemo, useEffect } from 'react';
import css from './index.module.scss';
import { seriesLinkProps } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import Exposure from '@/utils/isInViewPort';
import Button from '@/components/UI/Button';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import EFArrowLeftSmall from '@/components/UI/svg/Icons/EFArrowLeftSmall';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/collection/');

export default function SeriesType({ contentData, serieType, lang }: any) {
    const { Link, gtm } = useGlobal();

    const getData = (key: string) => lang[serieType] && lang[serieType][key];

    useEffect(() => {
        let exposure: Exposure;

        setTimeout(() => {
            exposure = new Exposure({
                callback: (node: any) => {
                    const elements = document?.querySelectorAll('.item-card-gtm');
                    const card = node?.closest('.item-card-gtm');
                    const bannerName = card?.querySelector('.title')?.innerHTML;
                    const position = Array.prototype.indexOf.call(elements, card);
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'view_banner',
                        banner_name: bannerName,
                        position: `banner_${position + 1}`,
                    });
                },
                once: true,
            });
            exposure.observe('.isInViewPort');
        }, 2000);
        return () => {
            exposure?.disconnect();
            exposure = null;
        };
    }, [contentData, serieType]);

    useEffect(() => {
        // 点击埋点
        const container = document.querySelector('.series-con-item');
        const elements = document?.querySelectorAll('.item-card-gtm');
        const gtmPush = (e: Event) => {
            const target = e.target as HTMLLinkElement;
            const card = target?.closest('.item-card-gtm');
            const Link = target?.closest('a');
            const bannerName = card?.querySelector('.title')?.innerHTML;
            const position = Array.prototype.indexOf.call(elements, card);

            if (!card || !Link) return;
            let button_name = 'Image';
            if (target.tagName !== 'IMG') {
                button_name = 'Learn more';
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'select_banner',
                banner_name: bannerName,
                position: `banner_${position + 1}`,
                button_name: button_name,
            });
        };
        container?.addEventListener('click', gtmPush);

        return () => container?.removeEventListener('click', gtmPush);
    }, [contentData, serieType]);

    const Dom = useMemo(() => {
        return (
            <>
                {[contentData].map((contentData: any) => (
                    <div key={contentData?.type} className={`${css.riverSeries} series-con-item-${serieType} series-con-item`}>
                        <div className="banner-content">
                            <div className="container banner-container">
                                {contentData?.stage1?.map((item: any, itemIndex: number) => (
                                    <div className="box item-card-gtm" key={contentData?.type + item.title}>
                                        <div className="box-item">
                                            {item.isNew && (
                                                <span
                                                    className="new font-family-extralight"
                                                    style={{
                                                        visibility: item.isNew ? 'visible' : 'hidden',
                                                    }}
                                                >
                                                    {getData('new')}
                                                </span>
                                            )}
                                            <h1 className="title font-family-bold">{getData(item.title)}</h1>
                                            <p
                                                className="des font-family-medium"
                                                style={{
                                                    display: item.subTitle ? 'block' : 'none',
                                                }}
                                            >
                                                {getData(item.subTitle)}
                                            </p>
                                            {item.detailsLink && (
                                                <div className="link">
                                                    <Link {...seriesLinkProps(item)} ariaLabel={getData(item.title)}>
                                                        <Button type="link" className="link-btn font-family-medium" aria-label={getData(item.title)}>
                                                            {getData(item.detailText)}
                                                            <span className="more ">
                                                                <EFArrowLeft />
                                                            </span>
                                                        </Button>
                                                    </Link>
                                                </div>
                                            )}
                                        </div>
                                        <span className="top-imgs">
                                            <EFPic
                                                name={[`${item.images}.webp`, `${item.images}.png`]}
                                                // layout="fill"
                                                className="fullImgs isInViewPort"
                                                data-banner-name={getData(item.title)}
                                                data-position={`banner_${getData(item.title)}_${itemIndex + 1}`}
                                                alt={getData(item.title)}
                                            />
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {contentData?.stage2?.map((item: any) => (
                            <section key={contentData?.type + item.bigTitle} className="section">
                                {item.bigTitle && (
                                    <div className="series-title">
                                        <h2>{getData(item.bigTitle)}</h2>
                                    </div>
                                )}
                                {item.bigArr?.map((biglist: any, listIndex: number) => (
                                    <div className="bottom-content middle-content section-container" key={contentData?.type + biglist.title}>
                                        <div className="container item-card-gtm">
                                            <div className="items">
                                                <div className="box left">
                                                    {item.isNew && (
                                                        <span
                                                            className="new font-family-extralight"
                                                            style={{
                                                                visibility: biglist.isNew ? 'visible' : 'hidden',
                                                            }}
                                                        >
                                                            {getData('new')}
                                                        </span>
                                                    )}
                                                    <h2 className="title">{getData(biglist.title)}</h2>
                                                    <p
                                                        className="subtitle font-family-medium"
                                                        style={{
                                                            display: biglist.subTitle ? 'block' : 'none',
                                                        }}
                                                    >
                                                        {getData(biglist.subTitle)}
                                                    </p>
                                                    {biglist.detailsLink && (
                                                        <div className="link">
                                                            <Link {...seriesLinkProps(biglist)} ariaLabel={getData(biglist.title)}>
                                                                <Button type="link" className="link-btn font-family-medium" aria-label={getData(biglist.title)}>
                                                                    {getData(biglist.detailText)}
                                                                    <span className="more">
                                                                        <EFArrowLeft />
                                                                    </span>
                                                                </Button>
                                                            </Link>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="right">
                                                    <Link {...seriesLinkProps(biglist)} ariaLabel={getData(biglist.title)}>
                                                        <span className={biglist.hoverImages ? 'right-imgs' : 'right-img'}>
                                                            <EFPic
                                                                name={[`${biglist.images}.webp`, `${biglist.images}.png`]}
                                                                className="fullImgs imga1 isInViewPort"
                                                                data-banner-name={getData(biglist.title)}
                                                                data-position={`banner_${getData(item.bigTitle)}_${listIndex + 1}`}
                                                                alt={getData(biglist.title)}
                                                            />
                                                            {biglist.hoverImages && (
                                                                <EFPic
                                                                    name={[`${biglist.hoverImages}.webp`, `${biglist.hoverImages}.png`]}
                                                                    className="fullImgs imga2"
                                                                    alt={getData(biglist.title)}
                                                                />
                                                            )}
                                                        </span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="section-container product-list">
                                    <ul>
                                        {item.arr?.map((list: any, listIndex: number) => (
                                            <li key={contentData?.type + list.title}>
                                                <div className={`box item-card-gtm ${getData(list.title) === 'Smart Generator (Dual Fuel)' ? 'dg200' : ''}`}>
                                                    {list.isNew && (
                                                        <span
                                                            className="new font-family-extralight"
                                                            style={{
                                                                visibility: list.isNew ? 'visible' : 'hidden',
                                                            }}
                                                        >
                                                            {getData('new')}
                                                        </span>
                                                    )}
                                                    <div className="header">
                                                        <h2 className="title">{getData(list.title)}</h2>
                                                        <p
                                                            className="des"
                                                            style={{
                                                                display: list.subTitle ? 'block' : 'none',
                                                            }}
                                                        >
                                                            {getData(list.subTitle)}
                                                        </p>
                                                        {list.detailsLink && (
                                                            <div className="link">
                                                                <Link {...seriesLinkProps(list)} ariaLabel={getData(list.title)}>
                                                                    <Button
                                                                        type="link"
                                                                        className="link-btn small-link-btn font-family-medium"
                                                                        aria-label={getData(list.title)}
                                                                    >
                                                                        {getData(list.detailText)}
                                                                        <span className="more">
                                                                            <EFArrowLeftSmall
                                                                                style={{
                                                                                    fontSize: '11px',
                                                                                }}
                                                                            />
                                                                        </span>
                                                                    </Button>
                                                                </Link>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <Link {...seriesLinkProps(list)} ariaLabel={getData(list.title)}>
                                                        <span className={list.hoverImages ? 'box-imgs signFullImgsBox' : 'box-img signFullImgsBox'}>
                                                            <EFPic
                                                                name={[`${list.images}.webp`, `${list.images}.png`]}
                                                                className="fullImgs imga1 isInViewPort"
                                                                data-banner-name={getData(list.title)}
                                                                data-position={`banner_${getData(item.bigTitle)}_${listIndex + 1 + (item.bigArr?.length || 0)}`}
                                                                alt={getData(list.title)}
                                                            />
                                                            {list.hoverImages && (
                                                                <EFPic
                                                                    name={[`${list.hoverImages}.webp`, `${list.hoverImages}.png`]}
                                                                    className="fullImgs imga2"
                                                                    alt={getData(list.title)}
                                                                />
                                                            )}
                                                        </span>
                                                    </Link>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </section>
                        ))}
                        {contentData?.stage3?.map((item: any) => (
                            <section key={contentData?.type + item.title}>
                                <div className="series-title">
                                    <h2>{getData(item.title)}</h2>
                                </div>
                                <div className="product-list product-list-bb section-container">
                                    <ul>
                                        {item.arr?.map((list: any, listIndex: number) => (
                                            <li key={contentData?.type + item.title + list.title}>
                                                <div className="box item-card-gtm">
                                                    <Link {...seriesLinkProps(list)} ariaLabel={getData(list.title)}>
                                                        <span className="box-img">
                                                            <EFPic
                                                                name={[`${list.images}.webp`, `${list.images}.png`]}
                                                                className="fullImgs isInViewPort"
                                                                data-banner-name={getData(list.title)}
                                                                data-position={`banner_${getData(item.title)}_${listIndex + 1}`}
                                                                alt={getData(list.title)}
                                                            />
                                                        </span>
                                                    </Link>
                                                    <h2 className="title">{getData(list.title)}</h2>
                                                    <p
                                                        className="des"
                                                        style={{
                                                            display: list.subTitle ? 'block' : 'none',
                                                        }}
                                                    >
                                                        {getData(list.subTitle)}
                                                    </p>
                                                    {list.detailsLink && (
                                                        <div className="link">
                                                            <Link {...seriesLinkProps(list)} ariaLabel={getData(list.title)}>
                                                                <Button type="link" className="link-btn font-family-medium" aria-label={getData(list.title)}>
                                                                    {getData(list.detailText)}
                                                                    <span className="more">
                                                                        <EFArrowLeft />
                                                                    </span>
                                                                </Button>
                                                            </Link>
                                                        </div>
                                                    )}
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </section>
                        ))}
                        {contentData?.stage4?.map((item: any, itemIndex: number) => (
                            <section className="bbSelect" key={contentData?.type + item.title}>
                                <div className="bottom-content section-container item-card-gtm">
                                    <div className="bbg">
                                        <EFPic
                                            name={[`${item.images}.webp`, `${item.images}.png`]}
                                            className="fullImgs isInViewPort"
                                            data-banner-name={getData(item.title)}
                                            data-position={`banner_${getData(item.title)}_${itemIndex + 1}`}
                                            alt={getData(item.title)}
                                        />
                                    </div>
                                    <div className="container ">
                                        <div className="box left">
                                            <h2 className="title">{getData(item.title)}</h2>
                                            <p
                                                className="subtitle font-family-medium"
                                                style={{
                                                    display: item.subTitle ? 'block' : 'none',
                                                }}
                                            >
                                                {getData(item.subTitle)}{' '}
                                            </p>
                                            {item?.detailText && (
                                                <Link {...seriesLinkProps(item)} ariaLabel={getData(item.title)}>
                                                    <Button type="link" className="link link-btn last font-family-medium" aria-label={getData(item.title)}>
                                                        {getData(item.detailText)}
                                                        <span className="more">
                                                            <EFArrowLeft />
                                                        </span>
                                                    </Button>
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        ))}
                    </div>
                ))}
            </>
        );
    }, [contentData, serieType]);

    return <>{Dom}</>;
}
